var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dataQueryTemplate2',{ref:"dataQueryTemplate2"})
}
var staticRenderFns = []

export { render, staticRenderFns }